module.exports = __webpack_public_path__ + "img/pic13.0cc94646.png";